module.exports = __webpack_public_path__ + "img/15order.8ba0de80.png";